export type DeviceEventsProps = {
  deviceId?: string | number | null;
  disabled?: boolean;
};

export type DeviceEventsTab = "events" | "stored";

export const EVENT_PAGE_SIZES = [50, 100, 500, 1000];
